import { Column } from "@/components/Column";
import { Text } from "@/components/Text";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS } from "@/lib/mixpanel/types";

// Interstitial before handing a candidate to the AI scheduling agent when a
// guardrail applies (past submit stage, recent human outreach). Manual
// shortlists never hit this.
export const AgentSchedulingGuardrailDialog = ({
  onClose,
  onShortlistManually,
  onUseAgent,
  reasons,
  screenName,
}: {
  onClose: () => void;
  onShortlistManually: () => void;
  onUseAgent: () => void;
  reasons: string[];
  screenName: MIXPANEL_SCREENS;
}) => {
  /* Handlers */
  const handleShortlistManually = () => {
    mixpanelUtils.trackButtonClick(
      "Agent Guardrail: Shortlist Manually",
      screenName,
      { reasons },
    );
    onClose();
    onShortlistManually();
  };

  const handleUseAgent = () => {
    mixpanelUtils.trackButtonClick(
      "Agent Guardrail: Use AI Scheduling Agent",
      screenName,
      { reasons },
    );
    onClose();
    onUseAgent();
  };

  /* Render */
  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent className="flex flex-col gap-8">
        <DialogHeader className="flex flex-col gap-4">
          <DialogTitle className="text-2xl font-semibold text-slate-700">
            Start agent scheduling anyway?
          </DialogTitle>
          <DialogDescription className="!m-0 text-base font-medium text-slate-700">
            This candidate may not be a good fit for the AI scheduling agent:
          </DialogDescription>
        </DialogHeader>
        <Column className="gap-2">
          {reasons.map((reason) => (
            <Text key={reason} className="text-base font-medium text-slate-700">
              • {reason}
            </Text>
          ))}
        </Column>
        <DialogFooter>
          <Button
            className="rounded-full"
            onClick={handleShortlistManually}
            variant="secondary"
          >
            Shortlist without the agent
          </Button>
          <Button className="rounded-full" onClick={handleUseAgent}>
            Use AI Scheduling Agent
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};